import React from 'react';
import moment from 'moment';
import { getName, objectSort } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';
import { VideoCallStatusUpdate } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { CallDeclineIcon, MissedCallIcon } from '../Common/Icons';

export const filterNotifications = (notificationList = []) => {
  let list = notificationList.filter(
    (notification) =>
      notification.call_status__status === VideoCallStatusUpdate.declined ||
      notification.call_status__status === VideoCallStatusUpdate.missed ||
      notification.hasOwnProperty('duration')
  );
  list = list.sort((a, b) => objectSort('utc_timestamp_inms')(b, a));
  return list;
};

export const hasDashboardAccess = (rolename) => rolename === 'Manage' || rolename === 'Care';

export const processNotifications = (notifList = [], currentHub, trans) => {
  if (!currentHub) return {};
  let listObj = {};
  notifList.forEach((notification) => {
    const { call_status__status, invited_contacts, event_originator_id, utc_timestamp_inms } =
      notification;
    let obj = {};
    if (
      invited_contacts.length === 2 &&
      invited_contacts.some((c) => c.useruuid === currentHub?.useruuid)
    ) {
      let otherUser = (invited_contacts ?? []).find((c) => c.useruuid !== currentHub?.useruuid);

      if (otherUser.useruuid in listObj) return;

      if (call_status__status === VideoCallStatusUpdate.declined)
        obj.icon = <CallDeclineIcon className="event-icon grey" />;
      else if (call_status__status == VideoCallStatusUpdate.missed)
        obj.icon = <MissedCallIcon className="event-icon red" />;

      let desc = '';
      if (event_originator_id === currentHub?.useruuid) {
        desc += getName(currentHub) + ` ${trans('CALLED_L')}`;
      } else desc += `${trans('CALLED')} ` + getName(currentHub);

      const timestamp = moment(utc_timestamp_inms);
      const isToday = timestamp.isSame(moment(), 'day');
      const isYesterday = timestamp.isSame(moment().subtract(1, 'day'));
      if (isToday) {
        desc += ` ${trans('TODAYAT')} ` + timestamp.format('h:mm A');
      } else if (isYesterday) {
        desc += ` ${trans('YESTERDAYAT')} ` + timestamp.format('h:mm A');
      } else {
        desc +=
          ` ${trans('ON_L')} ` +
          timestamp.format('dddd') +
          ` ${trans('AT')} ` +
          timestamp.format('h:mm A');
      }
      obj.desc = desc;
      listObj[otherUser.useruuid] = obj;
    }
  });
  return listObj;
};
